import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import NavbarDefault from "./components/navbarDefault";
import { CardActionArea, createTheme, responsiveFontSizes } from '@mui/material';
import FooterDefault from "./components/footerDefault";
import { Link } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';

import oblation from './images/oblation2.webp';

import { ThemeProvider } from '@emotion/react';

var questions = [
  {
    question: "What are the guidelines for the BS Computer Science undergraduate program admissions, enrollment, shifting, and transferring?",
    link: "https://dcs.upd.edu.ph/admissions/undergraduate-program-admissions/",
    pdf: false
  },
  {
    question: "What is the BS Computer Science undergraduate curriculum?",
    link: "/FAQs/BSCSCurriculum",
    pdf: false
  },
  {
    question: "What are the Computer Science undergraduate course subjects?",
    link: "/FAQs/BSCSCourseSubjects",
    pdf: false
  },
  {
    question: "What are the admission guidelines and course curriculum of the MS Bioinformatics graduate program?",
    link: "/FAQs/MSBI",
    pdf: false
  },
  {
    question: "What are the admission guidelines and course curriculum of the MS Computer Science graduate program?",
    link: "/FAQs/MSCS",
    pdf: false
  },
  {
    question: "What are the admission guidelines and course curriculum of the PhD Computer Science graduate program?",
    link: "/FAQs/PHDCS",
    pdf: false
  },
  {
    question: "What is UP Diliman's 2022-2023 academic year calendar?",
    link: "https://our.upd.edu.ph/acadcal.php",
    pdf: false
  },
  {
    question: "What are the student organizations under DCS?",
    link: "/FAQs/StudentOrganizations",
    pdf: false
  },
  {
    question: "How do I file a leave of absence (LOA)?",
    link: "https://our.upd.edu.ph/files/flowchart/newloa.pdf",
    pdf: false
  },
  {
    question: "What is the maximum residency rule (MRR)?",
    link: "https://our.upd.edu.ph/files/acadinfo/MAXIMUM%20RESIDENCE_Undergraduate.pdf",
    pdf: false
  },
  {
    question: "What are the DCS Facilities available for reservations and what is the process for booking them?",
    link: "/FAQs/Facilities",
    pdf: false
  },
  {
    question: "template",
    link: false,
    pdf: "SamplePDF.pdf", 
    pageTitle: "template"
  },
]

let theme = createTheme({
  typography: {
    fontFamily: [
      'Segoe UI', 
      'sans-serif',
    ].join(','),
  }
});

theme = responsiveFontSizes(theme);

var searchKey = ""

function FAQs() {

  const [filteredFAQS, setFilteredFAQS] = useState(questions)

  const bannerStyle = { width: "100%", maxHeight: "40vh", minHeight: "100px", objectFit: "cover", objectPosition: "center", filter: "brightness(0.6)" };
  const bannerText = { color: "white", position: "absolute", top: "60%", left: "30%", transform: "translate(-50%, -50%)", textAlign: "left" };

  const gridStyle = { flexGrow: 1, paddingBottom: 0, paddingRight: 2, marginTop: 2, marginLeft: "auto", marginRight: "auto", maxWidth: 1, alignItems: "center" };
  const cardStyle = { width: 1, height: "100%", boxShadow: 5 };

  const SearchbyKeyword = (keyword) => {
    setFilteredFAQS([])
    for (let i=0; i < questions.length; i++){
      if (questions[i].question.toLowerCase().includes(keyword)){
        setFilteredFAQS((prev)=>{
          return[...prev,questions[i]];
        });
      }
    }
  }

  return (
    <ThemeProvider theme={theme}>

      {/* NAVIGATION BAR */}
      <NavbarDefault />

      {/* PAGE BANNER */}
      <div style={{position: 'relative', textAlign: 'center'}}>

        {/* BANNER IMAGE */}
        <img src={oblation} style={bannerStyle} alt="Oblation Banner"/>

        {/* BANNER TEXT */}
        <ThemeProvider theme={theme}>
          <Typography gutterBottom variant="h3" marginLeft={5} style={bannerText}>
            <b>FREQUENTLY <br/>
              <Typography variant="h5">
                ASKED QUESTIONS
              </Typography>
            </b>
          </Typography>
        </ThemeProvider>
      </div>

      <Grid container spacing={1} justifyContent="center" sx={gridStyle} style={{ padding: "10px 5px"}}>
        <Grid item>
          <TextField label="Search by Keyword" variant="outlined" sx ={{ width: { sm: 300, md: 600 } }} size="small" fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment>
                    <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(event) => {
              event.preventDefault()
              searchKey = event.target.value.trim().toLowerCase()
              SearchbyKeyword(searchKey);
            }}
            >
          </TextField> 
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" sx={gridStyle} spacing={2}>
        {filteredFAQS.map((question) => (
          <Grid item xs={8}>
            <Card sx={cardStyle}>
              {question.link !== false ?
              <CardActionArea href={question.link} style={{textDecoration: 'none'}} sx={{":hover": {color:"black"}}}>
                <CardContent>
                  <ThemeProvider theme={theme}>
                    <Typography gutterBottom variant="h6" component="div" marginLeft={1} marginRight={1} marginBottom={0}>
                      <b>{question.question}</b>
                    </Typography>
                  </ThemeProvider>
                </CardContent>
              </CardActionArea>
                :
              <Link to={`/FAQs/DocumentViewer/${question.pdf}`} state = {{title: question.pageTitle}} style={{textDecoration: 'none'}} sx={{color:'black'}}>
                <CardActionArea  style={{textDecoration: 'none', color: 'black'}} sx={{":hover": {color:"black"}}}>
                  <CardContent>
                    <ThemeProvider theme={theme}>
                      <Typography gutterBottom variant="h6" component="div" marginLeft={1} marginRight={1} marginBottom={0}>
                        <b>{question.question}</b>
                      </Typography>
                    </ThemeProvider>
                  </CardContent>
                </CardActionArea>
              </Link>
              }
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* FOOTER IMAGE ATTRIBUTION */}
      <div style={{padding: "20px"}}>
        <Typography fontSize="9px" style={{ textAlign: "center" }}>
            Image Attribution: <a href="https://upd.edu.ph/sites-of-interest/" style={{color: "black"}}>UP Oblation</a> by Jefferson Villacruz via UP Diliman Website
        </Typography>
      </div>

      {/* FOOTER NAVIGATION */}
      <FooterDefault />  

    </ThemeProvider>
  )
}

export default FAQs